import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { User } from 'src/features/auth';

const RESOURCE = '/users/:userId/';

interface DTO {
    userId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ userId }: DTO): Promise<User> => {
    return axios.get(formatResourcePath(RESOURCE, { userId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        // 10 Minutes
        staleTime: 10 * 60 * 1000,
        ...config,
    });

export { RESOURCE as GET_USER_RESOURCE, queryFn as getUser, useQueryHook as useGetUser };
export type { DTO as GetUserDTO };
